module.exports = __webpack_public_path__ + "img/selected0-min.80fa1a47.png";